var _g, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgEditBirthdays(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 36,
    height: 36,
    viewBox: "0 0 36 36",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1326_3416)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M9.50409 6.46201C10.6875 6.46201 11.6468 5.50232 11.6468 4.31854C11.6468 3.52963 10.6953 1.7579 10.0603 0.663623C9.81255 0.236475 9.1957 0.236475 8.94785 0.663623C8.313 1.7579 7.36139 3.52963 7.36139 4.31854C7.36139 5.50232 8.32073 6.46201 9.50409 6.46201Z",
    fill: "#1BBDD4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M27.1427 6.46201C28.3261 6.46201 29.2854 5.50232 29.2854 4.31854C29.2854 3.52963 28.3339 1.7579 27.6989 0.663623C27.4512 0.236475 26.8343 0.236475 26.5865 0.663623C25.9516 1.7579 25 3.52963 25 4.31854C25 5.50232 25.9593 6.46201 27.1427 6.46201Z",
    fill: "#1BBDD4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18.1427 6.46201C19.3261 6.46201 20.2854 5.50232 20.2854 4.31854C20.2854 3.52963 19.3339 1.7579 18.6989 0.663623C18.4512 0.236475 17.8343 0.236475 17.5865 0.663623C16.9516 1.7579 16 3.52963 16 4.31854C16 5.50232 16.9593 6.46201 18.1427 6.46201Z",
    fill: "#1BBDD4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.32437 8.22314C7.80026 8.22314 7.37537 8.64818 7.37537 9.1725V16.8312H11.6328V9.17257C11.6328 8.64825 11.208 8.22322 10.6838 8.22322H8.32437V8.22314Z",
    fill: "#1BBDD4"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M25.014 9.1725C25.014 8.64818 25.4389 8.22314 25.963 8.22314L27.1427 8.22322L25.014 10.3519V9.1725Z",
    fill: "#1BBDD4"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M16.014 9.1725C16.014 8.64818 16.4389 8.22314 16.963 8.22314L19.3224 8.22322C19.8466 8.22322 20.2714 8.64825 20.2714 9.17257V14.5L17.9402 16.8312H16.014V9.1725Z",
    fill: "#1BBDD4"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M5.1803 24.9621C5.00565 25.0138 4.82993 25.038 4.65823 25.038C3.80633 25.038 3.05609 24.4417 3.05609 23.6496V20.9305C3.05609 20.0291 3.90125 19.2983 4.94384 19.2983H16.1071L11.5619 23.8435C11.2186 23.8062 10.8733 23.7875 10.528 23.7875C9.62054 23.7875 8.71301 23.9163 7.84276 24.174L5.1803 24.9621ZM26.5105 23.844C27.0677 23.9048 27.6196 24.0148 28.1572 24.174L30.8196 24.9621C30.9942 25.0138 31.1701 25.038 31.3417 25.038C32.1937 25.038 32.9439 24.4417 32.9439 23.6496V20.9305C32.9439 20.0291 32.0987 19.2983 31.0561 19.2983L26.5105 23.844Z",
    fill: "#1BBDD4"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M32.0663 33.5476H34.9453C35.5278 33.5476 36 34.0199 36 34.6024C36 35.1848 35.5278 35.6571 34.9453 35.6571H15.0181H13.2488L15.6013 35.0739L24.7427 25.9325C24.984 25.9089 25.2273 25.897 25.472 25.897C26.1847 25.897 26.8867 25.9978 27.5584 26.1966L30.2209 26.9848C30.5854 27.0927 30.9626 27.1474 31.3417 27.1474C31.5868 27.1474 31.8293 27.124 32.0663 27.0796V33.5476ZM9.5 25.9679C9.14097 26.018 8.7873 26.0943 8.44165 26.1966L5.7792 26.9848C5.41455 27.0927 5.03747 27.1475 4.65834 27.1475C4.41316 27.1475 4.17073 27.1241 3.93377 27.0797V31.5342V33.5477H1.05469C0.472219 33.5477 0 34.0199 0 34.6024C0 35.1848 0.472219 35.6571 1.05469 35.6571H5.15852L7.61556 27.8524L9.5 25.9679Z",
    fill: "#1BBDD4"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M29.2929 7.29289C29.6834 6.90237 30.3166 6.90237 30.7071 7.29289L35.7071 12.2929C36.0977 12.6834 36.0977 13.3166 35.7071 13.7071L15.7071 33.7071C15.5779 33.8364 15.422 33.9228 15.2572 33.9665L8.27475 35.9615C7.92555 36.0613 7.54972 35.9639 7.29292 35.7071C7.03612 35.4503 6.93873 35.0745 7.0385 34.7253L9.03351 27.7428C9.07721 27.5779 9.16368 27.4221 9.29292 27.2929L25.2927 11.2931L29.2929 7.29289ZM10.4947 29.9088L13.0912 32.5054L9.45605 33.544L10.4947 29.9088ZM15 31.5858L11.4142 28L26 13.4142L29.5858 17L15 31.5858ZM31 15.5858L27.4142 12L30 9.41421L33.5858 13L31 15.5858Z",
    fill: "#F06543"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15 31.5858L11.4142 28L26 13.4142L29.5858 17L15 31.5858Z",
    fill: "#F06543"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1326_3416"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 36,
    height: 36,
    fill: "white"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgEditBirthdays);
export default __webpack_public_path__ + "static/media/edit-birthdays.6f44a01b8c4de12f441c8318d0c8230c.svg";
export { ForwardRef as ReactComponent };